module.exports = __webpack_public_path__ + "static/media/AlertCircle.dcdc18fc.svg";